import {SDrawerOrModal, SGeneralForms} from "shj-components";
import {Form} from "antd";
import {useEffect} from "react";

export const SearchModal = (props) => {
  const {open, values, onClose, onSearch} = props;
  const [form] = Form.useForm()

  useEffect(() => {
    if (open) {
      form.resetFields();
      form.setFieldsValue(values);
    }
  }, [open, values]);

  const onSearchOk = () => {
    const formValues = form.getFieldsValue()
    onSearch(formValues);
    onClose();
  }

  return <SDrawerOrModal
      mode={'modal'}
      title={'搜索'}
      okText={'确认'}
      open={open}
      onOk={onSearchOk}
      onCancel={onClose}
  >
    <SGeneralForms
        formConfig={{form}}
        layout={'vertical'}
        configs={[{
          formItem: [
            {spanCol: 12, label: '客户姓名', name: 'nameLike'},
            {spanCol: 12, label: '客户电话', name: 'phone'},
            {spanCol: 12, label: '线索ID', name: 'id'},
          ]
        }]}/>
  </SDrawerOrModal>
}